import { Box, Button, Checkbox, DialogActions, Link } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { UPDATE_APPRAISALS_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { UPDATE_HOMESALE_INFO_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { updateAppraisal } from 'modules/authorizations/store/actions/homesale.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import { getHomesaleInfo } from 'modules/authorizations/authorizations.actions';
import AuthServiceButtonEmailCardComponent from 'modules/emailTemplates/authEmailTemplates/authServiceButtonEmailCard.component';

const formatDate = value => {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-US');
};

const OrderDetailsCard = props => {
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    appraisalInfo,
    appraisalsSelected,
    vendors,
    isReadOnly,
    appTypes,
    fileId,
    bmaTemplates,
    appraisalTemplates,
    sentTemplates,
    communication,
    history
  } = props;

  const [openEmailCard, setOpenEmailCard] = useState(false);

  const sentBrokerTemplates =
    (sentTemplates &&
      sentTemplates.filter(s => s.authServiceId === appraisalInfo.homesaleId && s.segmentId === appraisalInfo.homesaleAppraisalId)) ||
    [];

  var wasOrdered = sentBrokerTemplates.length > 0;

  const mostRecent = wasOrdered
    ? sentBrokerTemplates.reduce((prev, current) =>
        new Date(prev.emailTemplateSentDate) > new Date(current.emailTemplateSentDate) ? prev : current
      )
    : null;

  const typeOptions =
    appTypes && appTypes.length > 0
      ? appTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const tabs = [
    {
      header: appraisalsSelected ? 'Appraisal Info' : 'BMA Info',
      order: 1,
      iconPath: ['fas', 'house'],
      subHeader: !appraisalsSelected ? `- ${vendors.find(b => b.vendorId === appraisalInfo?.vendorId)?.companyName ?? ''}` : ''
    }
  ];

  const brokerAgentSearchInfo = {
    searchingColumns: [
      { name: 'vendorId', title: 'Id' },
      { name: 'companyName', title: 'Company Name' }
    ],
    searchingColumnExtensions: [
      { columnName: 'vendorId', width: 150 },
      { columnName: 'companyName', width: 250 }
    ],
    searchingRows: vendors,
    nameKey: 'companyName',
    idKey: 'vendorId'
  };

  const appraisalSummaries = [
    {
      header: 'Agent Ranking',
      accessorKey: 'agentRanking',
      type: 'dropdown',
      options: ['1', '2', '3', '4'],
      required: false,
      value: appraisalInfo ? appraisalInfo.agentRanking : 0,
      tab: 1
    },
    { header: 'Ordered', accessorKey: 'ordered', type: 'date', required: false, value: appraisalInfo ? appraisalInfo.ordered : '', tab: 1 },
    {
      header: 'Appointment',
      accessorKey: 'appointment',
      type: 'date',
      required: false,
      value: appraisalInfo ? appraisalInfo.appointment : '',
      tab: 1
    },
    {
      header: 'Appraiser',
      accessorKey: 'vendorId',
      nameKey: 'companyName',
      nameValue: vendors.find(b => b.vendorId === appraisalInfo?.vendorId)?.companyName,
      type: 'advanced-search',
      searchInfo: brokerAgentSearchInfo,
      required: true,
      value: appraisalInfo ? appraisalInfo.vendorId : '',
      tab: 1,
      hideInTable: true
    },
    // {
    //   header: 'Agent Selected',
    //   accessorKey: 'isAgentSelected',
    //   type: 'checkbox',
    //   required: false,
    //   value: appraisalInfo ? appraisalInfo.isAgentSelected : false,
    //   tab: 1,
    //   Cell: ({ cell }) => <Checkbox name="agentSelected" label="Active" checked={cell.row.original.isAgentSelected} disabled={true} />
    // },
    {
      header: 'Applies to Type',
      accessorKey: 'appraisalTypeId',
      type: 'dropdown-v2',
      options: typeOptions,
      required: false,
      value: appraisalInfo ? appraisalInfo.appraisalTypeId : '',
      tab: 1
    },
    { header: 'Fee', accessorKey: 'fee', type: 'money', required: false, value: appraisalInfo ? appraisalInfo.fee : false, tab: 1 },
    {
      header: 'Canceled',
      accessorKey: 'cancelled',
      type: 'date',
      required: false,
      value: appraisalInfo ? appraisalInfo.cancelled : '',
      tab: 1
    },
    { header: 'By Whom', accessorKey: 'byWhom', type: 'text', required: false, value: appraisalInfo ? appraisalInfo.byWhom : '', tab: 1 },
    {
      header: 'Recommended By',
      accessorKey: 'recommendedBy',
      type: 'text',
      required: false,
      value: appraisalInfo ? appraisalInfo.recommendedBy : '',
      tab: 1
    },
    {
      header: 'Notes',
      accessorKey: 'notes',
      type: 'notes',
      showBelow: true,
      required: false,
      value: appraisalInfo ? appraisalInfo.notes : '',
      tab: 1
    },
    {
      dividerLine: true,
      tab: 1
    },
    {
      header: 'Appraised Value',
      accessorKey: 'mlsp',
      type: 'money',
      required: false,
      value: appraisalInfo ? appraisalInfo.mlsp : '',
      tab: 1
    },
    // {
    //   header: 'PSP Written',
    //   accessorKey: 'grossSalePrice',
    //   type: 'money',
    //   required: false,
    //   value: appraisalInfo ? appraisalInfo.grossSalePrice : '',
    //   tab: 1
    // },
    {
      header: 'Suggested List',
      accessorKey: 'suggestedList',
      type: 'date',
      required: false,
      value: appraisalInfo ? appraisalInfo.suggestedList : '',
      tab: 1
    },
    {
      header: 'Received Date',
      accessorKey: 'receivedDate',
      type: 'date',
      required: false,
      value: appraisalInfo ? appraisalInfo.receivedDate : '',
      tab: 1
    },
    {
      header: 'Reviewed By',
      accessorKey: 'reviewedBy',
      type: 'text',
      required: false,
      value: appraisalInfo ? appraisalInfo.reviewedBy : '',
      tab: 1
    },
    {
      header: 'Reviewed Date',
      accessorKey: 'reviewedDate',
      type: 'date',
      required: false,
      value: appraisalInfo ? appraisalInfo.reviewedDate : '',
      tab: 1
    },
    {
      header: 'Delay Reason',
      accessorKey: 'delayReason',
      type: 'notes',
      required: false,
      showBelow: false,
      value: appraisalInfo ? appraisalInfo.delayReason : '',
      tab: 1
    },
    {
      header: 'Required Repairs',
      accessorKey: 'requiredRepairs',
      type: 'notes',
      showBelow: false,
      required: false,
      value: appraisalInfo ? appraisalInfo.requiredRepairs : '',
      tab: 1
    }
  ];

  const bmaSummaries = [
    {
      header: 'Broker',
      accessorKey: 'vendorId',
      nameKey: 'companyName',
      nameValue: vendors.find(b => b.vendorId === appraisalInfo?.vendorId)?.companyName,
      type: 'advanced-search',
      searchInfo: brokerAgentSearchInfo,
      required: true,
      value: appraisalInfo ? appraisalInfo.vendorId : '',
      tab: 1,
      hideInTable: true
    },
    {
      header: 'Broker Selected',
      accessorKey: 'isAgentSelected',
      type: 'checkbox',
      required: false,
      value: appraisalInfo ? appraisalInfo.isAgentSelected : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="isAgentSelected" label="Active" checked={cell.row.original.isAgentSelected} disabled={true} />
    },
    {
      header: 'Ordered',
      accessorKey: 'ordered',
      type: 'date',
      required: false,
      value: appraisalInfo ? appraisalInfo.ordered : '',
      tab: 1
    },
    {
      header: 'Appointment',
      accessorKey: 'appointment',
      type: 'date',
      required: false,
      value: appraisalInfo ? appraisalInfo.appointment : '',
      tab: 1
    },
    { header: 'Fee', accessorKey: 'fee', type: 'money', required: false, value: appraisalInfo ? appraisalInfo.fee : false, tab: 1 },
    {
      header: 'Canceled By',
      accessorKey: 'byWhom',
      type: 'dropdown',
      options: ['Agent', 'Homeowner', 'RC'],
      required: false,
      value: appraisalInfo ? appraisalInfo.byWhom : '',
      tab: 1
    },
    {
      header: 'Canceled Date',
      accessorKey: 'cancelled',
      type: 'date',
      required: false,
      value: appraisalInfo ? appraisalInfo.cancelled : '',
      tab: 1
    },
    {
      header: 'Recommended By',
      accessorKey: 'byWhom',
      type: 'text',
      required: false,
      value: appraisalInfo ? appraisalInfo.byWhom : '',
      tab: 1
    },
    {
      header: 'Agent Name',
      accessorKey: 'agentName',
      type: 'text',
      required: false,
      value: appraisalInfo ? appraisalInfo.agentName : '',
      tab: 1
    },
    {
      header: 'Agent Email',
      accessorKey: 'agentEmail',
      type: 'text',
      required: false,
      value: appraisalInfo ? appraisalInfo.agentEmail : '',
      tab: 1
    },
    {
      header: 'Agent Phone',
      accessorKey: 'agentPhone',
      type: 'text',
      required: false,
      value: appraisalInfo ? appraisalInfo.agentPhone : '',
      tab: 1
    },
    {
      header: 'Notes',
      accessorKey: 'notes',
      type: 'notes',
      showBelow: true,
      required: false,
      value: appraisalInfo ? appraisalInfo.notes : '',
      tab: 1
    },
    { dividerLine: true },
    // {
    //   header: 'Status',
    //   accessorKey: 'appraisalStatusId',
    //   type: 'dropdown-v2',
    //   options: statusEnum,
    //   required: false,
    //   value: appraisalInfo ? appraisalInfo.appraisalStatusId : '',
    //   tab: 1
    // },
    {
      header: 'Received Date',
      accessorKey: 'receivedDate',
      type: 'date',
      required: false,
      value: appraisalInfo ? appraisalInfo.receivedDate : '',
      tab: 1
    },
    {
      header: 'MLSP',
      accessorKey: 'mlsp',
      type: 'money',
      required: false,
      value: appraisalInfo ? appraisalInfo.mlsp : '',
      tab: 1
    },
    {
      header: 'SLP',
      accessorKey: 'grossSalePrice',
      type: 'money',
      required: false,
      value: appraisalInfo ? appraisalInfo.grossSalePrice : '',
      tab: 1
    },
    // {
    //   header: 'Suggested List',
    //   accessorKey: 'suggestedList',
    //   type: 'date',
    //   required: false,
    //   value: appraisalInfo ? appraisalInfo.suggestedList : '',
    //   tab: 1
    // },

    {
      header: 'Reviewed By',
      accessorKey: 'reviewedBy',
      type: 'text',
      required: false,
      value: appraisalInfo ? appraisalInfo.reviewedBy : '',
      tab: 1
    },
    {
      header: 'Delay Reason',
      accessorKey: 'delayReason',
      type: 'notes',
      required: false,
      showBelow: true,
      value: appraisalInfo ? appraisalInfo.delayReason : '',
      tab: 1
    }
    // {
    //   header: 'Reviewed Date',
    //   accessorKey: 'reviewedDate',
    //   type: 'date',
    //   required: false,
    //   value: appraisalInfo ? appraisalInfo.reviewedDate : '',
    //   tab: 1
    // },
    // {
    //   header: 'Org Name',
    //   accessorKey: 'orgName',
    //   type: 'text',
    //   required: false,
    //   value: appraisalInfo ? appraisalInfo.orgName : '',
    //   tab: 1
    // },
    // {
    //   header: 'Contact UID',
    //   accessorKey: 'contactUid',
    //   type: 'text',
    //   required: false,
    //   value: appraisalInfo ? appraisalInfo.contactUid : '',
    //   tab: 1
    // },
    // {
    //   header: 'Contact First',
    //   accessorKey: 'contactFirst',
    //   type: 'text',
    //   required: false,
    //   value: appraisalInfo ? appraisalInfo.contactFirst : '',
    //   tab: 1
    // },
    // {
    //   header: 'Contact Last',
    //   accessorKey: 'contactLast',
    //   type: 'text',
    //   required: false,
    //   value: appraisalInfo ? appraisalInfo.contactLast : '',
    //   tab: 1
    // },
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...appraisalInfo };

    if (values.vendorId != null) {
      const newAppraiser = vendors.find(v => v.vendorId === values.vendorId);
      newValues.vendorId = newAppraiser.vendorId;
    }
    newValues.agentRanking = values.agentRanking;
    newValues.isAgentSelected = values.isAgentSelected;
    newValues.appAppliesToTypeId = values.appAppliesToTypeId;
    newValues.appointment = values.appointment === '' ? null : values.appointment;
    newValues.fee = values.fee;
    newValues.cancelled = values.cancelled === '' ? null : values.cancelled;
    newValues.byWhom = values.byWhom ? values.byWhom : '';
    newValues.recommendedBy = values.recommendedBy;
    newValues.ordered = values.ordered === '' ? null : values.ordered;
    newValues.agentName = values.agentName;
    newValues.agentEmail = values.agentEmail;
    newValues.agentPhone = values.agentPhone;

    newValues.appraisalStatusId = values.appraisalStatusId;
    newValues.appraisedValueVerbal = values.appraisedValueVerbal;
    newValues.appraisedValueWritten = values.appraisedValueWritten;
    newValues.suggestedList = values.suggestedList;
    newValues.receivedDate = values.receivedDate === '' ? null : values.receivedDate;
    newValues.delayReason = values.delayReason;
    newValues.reviewedBy = values.reviewedBy;
    newValues.reviewedDate = values.reviewedDate === '' ? null : values.reviewedDate;
    newValues.orgName = values.orgName;
    newValues.contactUid = values.contactUid;
    newValues.contactFirst = values.contactFirst;
    newValues.contactLast = values.contactLast;

    newValues.notes = values.notes;
    newValues.grossSalePrice = values.grossSalePrice;
    newValues.mlsp = values.mlsp;
    newValues.appraisalStatusId = values.appraisalStatusId;
    newValues.suggestedList = values.suggestedList;
    newValues.receivedDate = values.receivedDate === '' ? null : values.receivedDate;
    newValues.delayReason = values.delayReason;
    newValues.reviewedBy = values.reviewedBy;
    newValues.reviewedDate = values.reviewedDate === '' ? null : values.reviewedDate;
    newValues.orgName = values.orgName;
    newValues.contactUid = values.contactUid;
    newValues.contactFirst = values.contactFirst;
    newValues.contactLast = values.contactLast;
    newValues.requiredRepairs = values.requiredRepairs;

    const resp = await props.updateAppraisal(fileId, newValues);
    if (resp.type === UPDATE_APPRAISALS_FAILURE) {
      props.showToast('Failed to update appraisal info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      await props.getHomesaleInfo(fileId);
      setIsLoading(false);
      return true;
    }
  };

  const notifyOfAppraisers = async () => {
    setIsLoadingButton(true);
    let newVals = { ...appraisalInfo };
    newVals.notifiedOfAppraiserSent = true;

    let resp = await props.updateAppraisal(fileId, newVals);
    if (resp.type === UPDATE_HOMESALE_INFO_FAILURE) {
      props.showToast('Failed to notify ee of Appraisers/Brokers, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      props.showToast('EE notified of Appraisers/Brokers successfully!', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
    }

    setIsLoadingButton(false);
    return resp;
  };

  const handleTemplateClick = commentId => {
    if (!commentId) return;
    history.push(`/authorizations/${fileId}/comments?commentId=${commentId}`);
  };

  const appraisalInfoButtons = ({ ...rest }) => {
    return (
      <>
        {isLoadingButton && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
            <DialogActions sx={{ p: '1.25rem' }}>
              <Spinner />
            </DialogActions>
          </Box>
        )}
        {!isLoadingButton && (
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '0 10px'
                }}
              >
                {!isReadOnly && !appraisalInfo.notifiedOfAppraiserSent && (
                  <Button
                    onClick={async () => await notifyOfAppraisers()}
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      marginLeft: '12px',
                      marginTop: '8px',
                      backgroundColor: '#868686',
                      '&:hover': { backgroundColor: '#474747' }
                    }}
                  >
                    {`Notify EE of ${appraisalsSelected ? 'Appraisers' : 'Brokers'}`}
                  </Button>
                )}
                {!isReadOnly && (
                  <Button
                    onClick={() => setOpenEmailCard(true)}
                    color="secondary"
                    variant="contained"
                    sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                    disabled={
                      appraisalsSelected && appraisalTemplates.length === 0
                        ? true
                        : !appraisalsSelected && bmaTemplates.length === 0
                        ? true
                        : false
                    }
                  >
                    {`${wasOrdered ? 'Reorder' : 'Order'} ${appraisalsSelected ? 'Appraisal' : 'BMA'}`}
                  </Button>
                )}
              </Box>
            </Box>
            {wasOrdered && mostRecent && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <Box>
                  {/* {appraisalInfo.notifiedOfAppraiserSent && (
                    <Typography color="secondary">
                      <FontAwesomeIcon size="1x" icon={['fas', 'fa-check-circle']} color="#5D9878" sx={{ marginRight: '13px' }} /> EE
                      notified of Agents/Brokers successfully{' '}
                      {!isReadOnly && (
                        <>
                          <Link onClick={async () => await notifyOfAppraisers()} sx={{ cursor: 'pointer' }}>
                            , click here
                          </Link>{' '}
                          to resend.
                        </>
                      )}
                    </Typography>
                  )} */}
                  <Link
                    component="button"
                    type="button"
                    underline="hover"
                    color="secondary"
                    onClick={() => handleTemplateClick(mostRecent.commentId)}
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
                  >
                    <FontAwesomeIcon size="1x" icon={['fas', 'fa-check-circle']} color="#5D9878" />
                    Appraisal/BMA ordered successfully. {formatDate(mostRecent.emailTemplateSentDate)}
                  </Link>
                </Box>
              </Box>
            )}
          </Box>
        )}
      </>
    );
  };

  return (
    <>
      {openEmailCard && (
        <AuthServiceButtonEmailCardComponent
          id={fileId}
          communication={communication}
          emailTemplates={appraisalsSelected ? appraisalTemplates : bmaTemplates}
          selectedTemplateProp={
            appraisalsSelected && appraisalTemplates.length === 1
              ? appraisalTemplates[0].templateId
              : !appraisalsSelected && bmaTemplates.length === 1
              ? bmaTemplates[0].templateId
              : ''
          }
          openModalDefault={true}
          selectedAuthServiceId={appraisalInfo.homesaleId}
          selectedSegmentServiceId={appraisalInfo.homesaleAppraisalId}
          onUnselectTemplate={() => setOpenEmailCard(false)}
        />
      )}
      <EditableCard
        tabs={tabs}
        summaries={appraisalsSelected ? appraisalSummaries : bmaSummaries}
        numColumns={5}
        updateFields={updateFields}
        isLoading={isLoading}
        ButtonComponent={appraisalInfoButtons}
        hideEdit={isReadOnly}
      />
    </>
  );
};

export default compose(
  connect(null, {
    updateAppraisal,
    showToast,
    getHomesaleInfo
  })
)(OrderDetailsCard);
